import { Action } from '@reduxjs/toolkit';
import { StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { pluck, filter, mergeMap } from 'rxjs/operators';

import { PLAYER_LIMITS_NOTIFICATION } from '@ezugi/constants';

import { socketActions, videoActions, dialogActions } from '../../actions';
import { REGULATIONS_OSS_DIALOG } from '../../constants/dialog';
import { isEvoWrappedSelector } from '../../selectors';
import { RootState } from '../../types';

const { socket } = socketActions;
const { video } = videoActions;
const { dialog } = dialogActions;

const regulationsEpicOSS = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(socket.message.match),
  pluck('payload'),
  filter(({ MessageType }: { MessageType: string }) => MessageType === PLAYER_LIMITS_NOTIFICATION
   && Boolean(isEvoWrappedSelector(state$.value))),
  pluck('data'),
  mergeMap((data) => of(dialog.add({ name: REGULATIONS_OSS_DIALOG, data }), socket.close(), video.shouldStop()))
);

export default regulationsEpicOSS;
